module.exports = __webpack_public_path__ + "static/media/gift-list2.18854852.png";